import { ActivityFilter, DateFilter, PlatformFilter, ProductFilter } from 'state/blotters/common/blotter.model';
import {
  BlotterType,
  FilterBlotterType,
  PageBlotterType,
  PreferenceBlotterType,
} from 'state/blotters/trades/types/types';

export interface GlobalFilters {
  blotterType: PageBlotterType & PreferenceBlotterType & FilterBlotterType;
}
export interface CommonTradesBlottersFilters {
  quickSearchTerm: string;
  activityFilter: ActivityFilter;

  advancedFilters: boolean;
  dateFilter: DateFilter;
  startDate?: string;
  endDate?: string;
}
export type SpecificTradesOrProductsBlotterFilters = {
  productFilter: ProductFilter;
  platformFilter: PlatformFilter;
  currencyFilter: string;
};
export function isSpecificTradesOrProductsBlotterFilters(
  _val: unknown,
  blotter: BlotterType,
): _val is SpecificTradesOrProductsBlotterFilters {
  return blotter === 'trades' || blotter === 'products';
}
export type TradesOrProductsBlotterFilters = CommonTradesBlottersFilters & SpecificTradesOrProductsBlotterFilters;
export type TradeBlottersFiltersByBlotterType<T extends FilterBlotterType> = T extends 'trades' | 'products'
  ? TradesOrProductsBlotterFilters
  : CommonTradesBlottersFilters;
export type AllTradeBlottersFiltersByBlotterType<T extends FilterBlotterType> = AllTradeBlottersFilters<
  TradeBlottersFiltersByBlotterType<T>
>;

export type AllTradeBlottersFilters<T extends CommonTradesBlottersFilters = CommonTradesBlottersFilters> = T &
  GlobalFilters;

export type Filter<T extends CommonTradesBlottersFilters> = keyof AllTradeBlottersFilters<T>;

export type FilterValue<T extends CommonTradesBlottersFilters> = AllTradeBlottersFilters<T>[Filter<T>];
